import React, { Component, useEffect, useState } from "react";

import { Close } from "../Svgs";
import styles from "./css/LeftNavbar.module.css";

const navbarLinks = [
  {
    urlTxt: "home",
    hrefTxt: "Home",
  },
  
  {
    hrefTxt: "Your Project",
    urlTxt: "your-project",
  },
  {
    hrefTxt: "About Us",
    urlTxt: "about-us",
  },
];

const LeftNavbar = (props) => {
  return (
    <div className={styles.navbarCont}>
      <div className={styles.navbarLogoCont}>
        <a to="/">
          <span className={styles.navbarLogoImage}>
            <img src="/assets/logo/allpromana.png" />
          </span>
          <span className={styles.navbarLogoText}>AllPromana</span>
        </a>
        <span className={styles.closeIcon} onClick={props.setLeftNavbar}>
          <Close style={{ color: "rgba(255,255,255,1)" }}></Close>
        </span>
      </div>
      <div className={styles.navbarLinks}>
        <ul>
          {navbarLinks.map((navLink, index) => (
            <li key={index}>
              <a href="">
                <span>{navLink["hrefTxt"]}</span>
              </a>
            </li>
          ))}
        </ul>
        <div className={styles.logoutBtnCont}>
        </div>
      </div>
    </div>
  );
};

export default LeftNavbar;
